
/*
 * Functionality for a countdown.
 */
(function($) {

  Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {
      s = "0" + s;
    }
    return s;
  }

  function defaultCountdownFormat() {
    return (this.getMonth() + 1).pad(2) + "/" + this.getDate().pad(2) + "/" +
      this.getFullYear() + " " + defaultFormatTime.apply(this, arguments);
  };

  function defaultFormatTime() {
    var hours = this.getHours();
    var am = hours < 12;
    if (!am) {
      hours = hours - 12;
    }
    if (hours === 0) {
      hours = 12;
    }
    return "" + hours.pad(2) + ":" + this.getMinutes().pad(2) + (am ? " AM" :
      " PM");
  }

  function getTimeRemaining(endtime, now) {
    if (!now) {
      now = Date.parse(new Date());
    }
    if (typeof endtime === 'string') {
      endtime = Date.parse(endtime);
    }
    var t = endtime - now;
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
      'total': t,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

 var Countdown = function(element, end, dateFormatFunc) {
    var that = this,
      now,
      timer,
      interval = 1000,
      intervalSeconds = interval / 1000,
      args = arguments,
      finished = false;

    that.defaultCountdownFormat = defaultCountdownFormat;
    that.defaultFormatTime = defaultFormatTime;

    if (typeof dateFormatFunc === 'function') {
      that.countdownFormat = dateFormatFunc;
    } else {
      that.countdownFormat = defaultCountdownFormat;
    }

    init.apply(that, args);

    function init() {
      element = $(element);
      if (element.closest('.countdown-finished').length > 0)
        return;

      try {
        now = new Date(!!now ? Date.parse(now) : Date.parse(element.attr(
          'data-now')));
        end = new Date(!!end ? Date.parse(end) : Date.parse(element.attr(
          'data-end')));
      } catch (ex) {
        console.log('Countdown: Error parsing date.', ex);
      }
      if (!end || (typeof(end.getTime) === 'function' && isNaN(end.getTime()))) {
        return;
      }

      that.end = end;
      that.now = now;

      $(that).trigger("countdown:init");
      onInterval();
      timer = setInterval(onInterval, interval);
    }

    function onInterval() {
      that.now.setSeconds(that.now.getSeconds() + intervalSeconds);
      that.remaining = getTimeRemaining(that.end, that.now);

      var t = Math.floor(that.remaining.total),
        tEnd = 1 * 1000;

      if (t <= tEnd) {
        onEndReached();
        $(that).trigger("countdown:end");
        return;
      }

      $(that).trigger("countdown:tick");
    }

    function onEndReached() {
      clearInterval(timer);
    }

    Object.defineProperty(that, 'showDays', {
      get: function() {
        return that.remaining.days > 0;
      }
    });
    Object.defineProperty(that, 'showHours', {
      get: function() {
        return that.showDays || (that.remaining.days === 0 && that.remaining
          .hours > 0);
      }
    });
    Object.defineProperty(that, 'showMinutes', {
      get: function() {
        return that.showDays || that.showHours || (that.remaining.hours ===
          0 && that.remaining.minutes > 0);
      }
    });
    Object.defineProperty(that, 'showSeconds', {
      get: function() {
        return that.showDays || that.showHours || that.showMinutes ||
          (that.remaining.minutes === 0 && that.remaining.seconds > 0);
      }
    });
  };

  function ready() {
    // Set up home page countdown
    var countdownWrapper = $('.masthead.countdown');
    var countdown = countdownWrapper.find('.countdown');
    setupCountdown(countdown, countdownWrapper);

    // Set up inner page countdown for UStream
    var ustreamCountdownWrapper = $(".inner-countdown");
    var ustream = $(".u-stream");
    if (ustreamCountdownWrapper.length > 0 && !ustreamCountdownWrapper.hasClass("countdown-finished")) {
        if (ustream.length > 0) {
            ustream.hide();
            ustream.detach();
        }
      
      var ustreamCountdown = ustreamCountdownWrapper.children('.countdown');
      setupCountdown(ustreamCountdown, ustreamCountdownWrapper, function () {
          if (ustream.length === 0) {
              return;
          }
        // On finished hide the whole thing and show the ustream content.
        ustream.insertAfter(ustreamCountdownWrapper);
        ustream.show();
        UStream.fixUI(ustream);
        ustreamCountdownWrapper.hide();
      });
    }
    else {
      UStream.fixUI(ustream);
    }
  }

  function setupCountdown(countdownElement, countdownWrapper, onFinished) {
    if (countdownElement.length <= 0) return;

    var days = countdownElement.find('.days'),
      dayData = days.children('span'),
      hours = countdownElement.find('.hours'),
      hourData = hours.children('span'),
      minutes = countdownElement.find('.minutes'),
      minuteData = minutes.children('span'),
      seconds = countdownElement.find('.seconds'),
      secondData = seconds.children('span');

    var countdown = $(new Countdown(countdownElement));
    countdown.on('countdown:end', function (e) {
      countdownWrapper.addClass("countdown-finished");
      if (typeof onFinished === 'function') {
        onFinished.apply(this, [e]);
      }
    });
    countdown.on('countdown:tick', function (e) {
      var remaining = e.target.remaining;
      dayData.text(remaining.days.pad(2));
      hourData.text(remaining.hours.pad(2));
      minuteData.text(remaining.minutes.pad(2));
      secondData.text(remaining.seconds.pad(2));

      if (e.target.showDays)
        countdownElement.removeClass('zero-days');
      else
        countdownElement.addClass('zero-days');
      if (e.target.showHours)
        countdownElement.removeClass('zero-hours');
      else
        countdownElement.addClass('zero-hours');
      if (e.target.showMinutes)
        countdownElement.removeClass('zero-minutes');
      else
        countdownElement.addClass('zero-minutes');
      if (e.target.showSeconds)
        countdownElement.removeClass('zero-seconds');
      else
        countdownElement.addClass('zero-seconds');
    });
  }

  $(ready);

  var ret = {};
  return ret;

})(jQuery);
